import type { IconSvgObject } from './types';

const LollipopIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "8", r: "6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 14V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 7.99776C7 6.5439 9 5.66871 10.2857 6.11842C11.7609 6.63438 12.0271 8.35853 13.5 8.88051C15 9.4121 16 7.99776 18 7.99776", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LollipopIcon;
